import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//scroll behavior 
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      //if (to.hash === '#anchor2') {
        //position.offset = { y: 100 }
      //}
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },

    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/AdminDash.vue')
    },

    {
      path: '/auditor',
      name: 'auditor',
      component: () => import(/* webpackChunkName: "auditor" */ './views/Auditor.vue'),
    },

    {
      path: '/auditor/covid-grant',
      name: 'covid-grant',
      component: () => import(/* webpackChunkName: "covid-grant" */ './views/auditor/CovidGrant.vue'),
    },

    {
      path: '/auditor/weights-measures-complaint',
      name: 'weights-measures-complaint',
      component: () => import(/* webpackChunkName: "weights-measures-complaint" */ './views/auditor/WeightsComplaint.vue'),
    },

    //{
    //  path: '/auditor/dogs',
    //  name: 'auditor-dogs',
    //  component: () => import(/* webpackChunkName: "auditor-dogs" */ './views/auditor/DogTags.vue'),
    //},

    //{
    //  path: '/auditor/dogs/:start/:end',
    //  name: 'auditor-dogs-range',
    //  component: () => import(/* webpackChunkName: "auditor-dogs-range" */ './views/auditor/DogTags.vue'),
    //},

    //{
    //  path: '/auditor/dog/:user/:tag',
    //  name: 'auditor-dog',
    //  component: () => import(/* webpackChunkName: "auditor-dog" */ './views/auditor/DogTag.vue'),
    //},

    {
      path: '/auditor/interesting-facts',
      name: 'interesting-facts',
      component: () => import(/* webpackChunkName: "interesting-facts" */ './views/auditor/InterestingFacts.vue'),
    },

    {
      path: '/auditor/real-estate',
      name: 'real-estate',
      component: () => import(/* webpackChunkName: "real-estate" */ './views/auditor/RealSearch.vue'),
    },

    {
      path: '/auditor/board-of-revision',
      name: 'board-of-revision',
      component: () => import(/* webpackChunkName: "real-estate" */ './views/auditor/BoardOfRevision.vue'),
    },

    {
      path: '/auditor/bor-complaints',
      name: 'bor-complaints',
      component: () => import(/* webpackChunkName: "real-estate" */ './views/auditor/BORComplaints.vue'),
    },

    {
      path: '/real-parcel/:id/:year',
      name: 'real-parcel',
      component: () => import(/* webpackChunkName: "real-parcel" */ './views/auditor/RealParcel.vue'),
    },

    {
      path: '/auto-dept',
      name: 'auto-dept',
      component: () => import(/* webpackChunkName: "auto-dept" */ './views/AutoDept.vue')
    },

    {
      path: '/clerk-of-courts',
      name: 'clerk-of-courts',
      component: () => import(/* webpackChunkName: "clerk-of-courts" */ './views/ClerkCourts.vue')
    },

    {
      path: '/commissioners',
      name: 'commissioners',
      component: () => import(/* webpackChunkName: "commissioners" */ './views/Commissioners.vue'),
    },

    {
      path: '/coronavirus',
      name: 'coronavirus',
      component: () => import(/* webpackChunkName: "coronavirus" */ './views/CoronaUpdate.vue'),
    },

    {
      path: '/court/appeals',
      name: 'court-appeals',
      component: () => import(/* webpackChunkName: "court-appeals" */ './views/courts/CourtAppeals.vue'),
    },

    {
      path: '/court/common-pleas',
      name: 'court-commplea',
      component: () => import(/* webpackChunkName: "court-commplea" */ './views/courts/CommonPleas.vue'),
    },

    {
      path: '/court/dillonvale',
      name: 'court-dillonvale',
      component: () => import(/* webpackChunkName: "court-dillonvale" */ './views/courts/CourtDillonvale.vue'),
    },

    {
      path: '/court/juvenile',
      name: 'court-juvenile',
      component: () => import(/* webpackChunkName: "court-juvenile" */ './views/courts/CourtJuvenile.vue'),
    },

    {
      path: '/court/probate',
      name: 'court-probate',
      component: () => import(/* webpackChunkName: "court-probate" */ './views/courts/CourtProbate.vue'),
    },

    {
      path: '/court/toronto',
      name: 'court-toronto',
      component: () => import(/* webpackChunkName: "court-toronto" */ './views/courts/CourtToronto.vue'),
    },

    {
      path: '/court/wintersville',
      name: 'court-wintersville',
      component: () => import(/* webpackChunkName: "court-wintersville" */ './views/courts/CourtWintersville.vue'),
    },

    {
      path: '/court/detention-center',
      name: 'court-detention',
      component: () => import(/* webpackChunkName: "court-detention" */ './views/courts/DetentionCenter.vue'),
    },

    {
      path: '/court/payments',
      name: 'court-payments',
      component: () => import(/* webpackChunkName: "court-payments" */ './views/courts/CourtPayments.vue'),
    },

    {
      path: '/court/case-lookup-and-payments',
      name: 'court-case-lookup-and-payments',
      component: () => import(/* webpackChunkName: "court-payments" */ './views/courts/CourtPayments.vue'),
    },

    {
      path: '/county-directory',
      name: 'county-directory',
      component: () => import(/* webpackChunkName: "county-directory" */ './views/CountyDirectory.vue'),
    },

    {
      path: '/downloadable-forms',
      name: 'downloadable-forms',
      component: () => import(/* webpackChunkName: "downloadable-forms" */ './views/DownloadableForms.vue'),
    },

    {
      path: '/ema',
      name: 'ema',
      component: () => import(/* webpackChunkName: "ema" */ './views/Ema.vue'),
    },

    {
      path: '/employee-resources',
      name: 'employee-resources',
      component: () => import(/* webpackChunkName: "employee-resources" */ './views/EmployeeResources.vue'),
    },

    {
      path: '/gis-construction',
      name: 'gis-construction',
      component: () => import(/* webpackChunkName: "gis-construction" */ './views/GisConstruction.vue'),
    },

    {
      path: '/law-library',
      name: 'law-library',
      component: () => import(/* webpackChunkName: "law-library" */ './views/LawLibrary.vue'),
    },

		{
      path: '/message-success',
      name: 'message-success',
      component: () => import(/* webpackChunkName: "message-success" */ './views/MessageSuccess.vue'),
    },

    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy-policy" */ './views/PrivacyPolicy.vue'),
    },

		{
      path: '/recorder',
      name: 'recorder',
      component: () => import(/* webpackChunkName: "recorder" */ './views/Recorder.vue'),
    },

		{
      path: '/regional-planning',
      name: 'regional-planning',
      component: () => import(/* webpackChunkName: "regional-planning" */ './views/RegionalPlanning.vue'),
    },
    
		{
      path: '/tax-sales',
      name: 'tax-sales',
      component: () => import(/* webpackChunkName: "tax-sales" */ './views/TaxSales.vue'),
    },

    {
      path: '/terms-of-use',
      name: 'terms-of-use',
      component: () => import(/* webpackChunkName: "terms-of-use" */ './views/TermsOfUse.vue'),
    },

    {
      path: '/treasurer',
      name: 'treasurer',
      component: () => import(/* webpackChunkName: "treasurer" */ './views/Treasurer.vue'),
    },

    {
      path: '/veterans-service',
      name: 'veterans-service',
      component: () => import(/* webpackChunkName: "veterans-service" */ './views/VeteransService.vue'),
    },

    {
      path: '/archive/auditor',
      name: 'auditor',
      component: () => import(/* webpackChunkName: "archive/auditor" */ './views/archive/Auditor.vue'),
    },

    {
      path: '*',
      name: 'catch_all',
      component: () => import(/* webpackChunkName: "catch_all" */ './views/Home.vue')
    }
  ]
})
